import {IxFetch, IxApi} from "^/IxPlugin/api";
import {catLink, debugLog, itemLink} from "^/utils"
import order from './modules/order'
import search from './modules/search'

const CACHE_NAV = 1000 * 60 * 10
const CACHE_CONFIG = 1000 * 60 * 10

const current_menu = 'menuv1'
const mx_link = '/mx/'
const item_link = '/item/'

function findMXNav(navs, value) {
  for (let i in navs) {
    let nav = navs[i],
        seo_link = catLink(nav.seo_link),
        result = [
          {
            id: nav.id,
            name: nav.name,
            seo_link: seo_link,
            active: (seo_link === value)
          }
        ]
    if (seo_link === value) {
      result.active = true
      return result
    } else {
      let sub = findMXNav(nav.menus, value)
      if (typeof sub !== 'undefined') {
        result = [...result, ...sub]
        return result
      }
    }
  }
  return undefined
}


async function findItemNav() {
  let item = window.stock_number,
      crumbs = [{name: 'Home', seo_link: '/'}],
      cats = []
  try {
    let cats_fetched = await IxFetch(IxApi.stockitems + item + '/mxcategories/')
    if (cats_fetched.status === 200) {
      cats = cats_fetched.data
    }
  } catch (e) {
    debugLog(e)
  }

  if (cats.length > 0) {
    let filtered_cats = cats.filter(e => (e.length > 1 && e[0].seo_link === current_menu))
    if (filtered_cats.length > 0) {
      filtered_cats[0].forEach(e => {
        if (e.seo_link !== current_menu) {
          e.seo_link = catLink(e.seo_link)
          crumbs.push(e)
        }
      })
    }
  }
  if (window.stock_item) {
    crumbs.push({
      name: window.stock_item.stock_number,
      seo_link: itemLink(window.stock_number),
      active: true
    })
  }
  return crumbs


}

let state = function () {
  return {
    config: {},
    configLastUpdate: 0,
    navigation: [],
    navLastUpdate: 0,
    currentNav: [],
  }
}

const getters = {
  storeConfig(state) {
    return state.config
  },
  getNav(state) {
    return state.navigation
  }
}

const mutations = {
  updateNav(state, payload) {
    state.navigation = payload
    state.navLastUpdate = Date.now()

  },
  updateCurrentNav(state, payload) {
    state.currentNav = payload
  },
  updateConfig(state, payload) {
    state.config = payload
    state.configLastUpdate = Date.now()
  }
}

const actions = {
  initPersistent({dispatch, state, commit,}) {
    let navigation = Promise.resolve(),
        config = Promise.resolve()
    if (Date.now() - state.navLastUpdate > CACHE_NAV) {
      navigation = IxFetch(IxApi.menus + current_menu + '/')
      navigation.then(e => dispatch('handleNavUpdate', e))
    }
    if (Date.now() - state.configLastUpdate > CACHE_CONFIG) {
      config = IxFetch(IxApi.config)
      config.then(e => dispatch('handleConfigUpdate', e))
    }
    return Promise.all([navigation, config]).then(dispatch('updateBreadCrumbs'))
  },
  async updateBreadCrumbs({commit, state, rootState}) {
    await rootState.initialization

    let location = window.location.pathname,
        nav = undefined
    if (location.match(mx_link)) {
      nav = findMXNav(state.navigation, location)
      if(typeof nav === 'undefined') nav =[{name:'Home',seo_link:'/'}];
      else nav = [{name:'Home',seo_link:'/'}, ...nav];
    }
    if (location.match(item_link)) {
      nav = await findItemNav()
    }
    if (typeof nav === 'undefined') {
      nav = window.mezz_crumbs
    }
    commit('updateCurrentNav', nav)

  },
  handleNavUpdate({commit, dispatch}, response) {
    if (response.status === 200) {
      commit('updateNav', response.data)
      dispatch('updateBreadCrumbs')
      return Promise.resolve(response)
    }
    dispatch('updateBreadCrumbs')
    return Promise.reject(response)
  },
  handleConfigUpdate({commit}, response) {
    if (response.status === 200) {
      commit('updateConfig', response.data)
      return Promise.resolve(response)
    }
    return Promise.reject(response)
  }
}

const modules = {
  order,
  search,
}

export default {
  state,
  getters,
  mutations,
  actions,
  modules,
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/persistent/index.js